export default "__VITE_ASSET__Cb6PLC_O__"